{
	"title": "Gestión de socios",
	"description": "Listado y registro de clientes y proveedores.",
	"pixKeyCopiedSuccess": "¡Clave PIX copiada con éxito!",
	"pixKeyCopyError": "Error al copiar la clave PIX",
	"name": "Nombre / Nombre comercial",
	"customerName": "Nombre",
	"namePlaceholder": "Ingrese el nombre comercial/nombre abreviado",
	"customerNamePlaceholder": "Ingrese el nombre",
	"legalName": "Razón social",
	"legalNamePlaceholder": "Ingrese Razón social/Nombre completo",
	"cpfOrCnpj": "NIF/CIF",
	"cpfOrCnpjPlaceholder": "Ingrese el NIF/CIF",
	"inscricaoEstadual": "Registro estatal",
	"inscricaoEstadualPlaceholder": "Ingrese el registro estatal",
	"cep": "Código postal",
	"cepPlaceholder": "Ingrese el código postal",
	"state": "Provincia",
	"statePlaceholder": "Ingrese la provincia",
	"city": "Ciudad",
	"cityPlaceholder": "Ingrese la ciudad",
	"street": "Dirección",
	"streetPlaceholder": "Ingrese la dirección",
	"streetNumber": "Número",
	"streetNumberPlaceholder": "Ingrese el número",
	"complemento": "Complemento",
	"complementoPlaceholder": "Ingrese el complemento",
	"neighborhood": "Barrio",
	"neighborhoodPlaceholder": "Ingrese el barrio",
	"bank": "Banco",
	"bankPlaceholder": "Ingrese el banco",
	"agency": "Sucursal",
	"agencyPlaceholder": "0000",
	"account": "Cuenta",
	"accountPlaceholder": "Ingrese la cuenta",
	"ownerName": "Titular de la cuenta",
	"ownerNamePlaceholder": "Ingrese el titular de la cuenta",
	"bankcpfOrCnpj": "NIF/CIF",
	"bankcpfOrCnpjPlaceholder": "Ingrese el NIF/CIF del titular",
	"phone": "Teléfono fijo",
	"cellPhone": "Teléfono móvil",
	"email": "Correo electrónico",
	"placeholderPhone": "(+34) 900 000 000",
	"placeholderCellPhone": "(+34) 600 000 000",
	"placeholderEmail": "ejemplo@email.com",
	"validateField": "Campo obligatorio",
	"wishToAdd": "¿Desea agregar?",
	"popConfirm": "¿Realmente desea eliminar este elemento?",
	"notInformed": "No informado",
	"address": "Dirección",
	"actions": "Acciones",
	"type": "Tipo",
	"addNewRegister": "Registrar socio",
	"editRegister": "Editar socio",
	"generalData": "Datos Generales",
	"bankData": "Detalles bancarios",
	"bankAccount": "Cuenta bancaria",
	"searchPlaceholder": "Buscar por cliente, proveedor, empleado",
	"infoMessage": "El tipo de registro está destinado a parametrizar los documentos financieros utilizados por un cliente, un proveedor o ambos.",
	"registerTypes": {
		"client": "Cliente",
		"supplier": "Proveedor",
		"customerAndSupplier": "Cliente y Proveedor",
		"employee": "Empleado"
	},
	"allPartners": "Todos los socios",
	"selectRegistrationType": "Seleccione el tipo de registro",
	"modalWarningCancel": {
		"title": "Descartar cambios"
	},
	"confirmCancelRegistration": {
		"title": "Cancelar registro",
		"message": "Estás creando un registro de socios. ¿Estás seguro de que quieres cancelar?",
		"confirmText": "Continuar registro",
		"cancelText": "Cancelar"
	},
	"invalidAgency": "Sucursal no válida",
	"invalidAccount": "Cuenta no válida",
	"invalidZipCode": "Código postal no válido",
	"invalidEmail": "Correo electrónico no válido",
	"supplierDetails": "Detalles del proveedor",
	"customerDetails": "Detalles del cliente",
	"employeeDetails": "Detalles del empleado",
	"customerAndSupplierDetails": "Detalles del cliente y proveedor",
	"viewDetails": "Ver detalles",
	"pixKeyType": "Tipo de Clave PIX",
	"pixKeyTypePlaceholder": "Seleccione el tipo",
	"pixKey": "Clave PIX",
	"pixKeyPlaceholder": "Ingrese la clave PIX",
	"pixKeyTypes": {
		"cpf": "CPF",
		"cnpj": "CNPJ",
		"email": "Correo electrónico",
		"phone": "Teléfono",
		"evp": "Clave Aleatoria"
	},
	"pixKeyPlaceholders": {
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "ejemplo@email.com",
		"phone": "(00) 00000-0000",
		"evp": "Clave aleatoria (UUID)"
	},
	"errors": {
		"unknown": "Error desconocido",
		"validationErrors": "Errores de validación:",
		"clearFieldError": "Limpiar error del campo",
		"cpfInvalid": "CPF inválido",
		"cnpjInvalid": "CNPJ inválido",
		"cpfMustHaveDigits": "El CPF debe tener 11 dígitos",
		"cnpjMustHaveDigits": "El CNPJ debe tener 14 dígitos",
		"emailInvalid": "Correo electrónico inválido",
		"phoneMustHaveDigits": "El teléfono debe tener 10 u 11 dígitos",
		"randomKeyInvalidChars": "La clave PIX debe contener solo números, letras y guiones",
		"randomKeyInvalidLength": "La clave PIX aleatoria debe tener el formato correcto de 36 caracteres",
		"randomKeyInvalidFormat": "Clave PIX inválida. Verifique si la copió correctamente de su banco"
	},
	"fieldNames": {
		"id": "ID",
		"name": "Nombre",
		"legalName": "Razón Social",
		"inscricaoEstadual": "Inscripción Estatal",
		"cpfOrCnpj": "CPF/CNPJ",
		"street": "Calle",
		"streetNumber": "Número",
		"complemento": "Complemento",
		"cep": "Código Postal",
		"state": "Estado",
		"city": "Ciudad",
		"neighborhood": "Barrio",
		"bank": "Banco",
		"agency": "Agencia",
		"account": "Cuenta",
		"bankcpfOrCnpj": "NIF/CIF",
		"ownerName": "Nombre del Titular",
		"phone": "Teléfono",
		"email": "Correo electrónico",
		"cellPhone": "Teléfono móvil",
		"registerType": "Tipo de Registro",
		"pixKeyType": "Tipo de Clave PIX",
		"pixKey": "Clave PIX"
	},
	"messages": {
		"pixKeyCopiedSuccess": "¡Clave PIX copiada exitosamente!",
		"pixKeyCopyError": "Error al copiar clave PIX"
	},
	"labels": {
		"pixKeyTypeUppercase": "TIPO DE CLAVE PIX",
		"pixKeyUppercase": "CLAVE PIX",
		"cpfCnpjUppercase": "CPF/CNPJ",
		"copyPixKey": "Copiar clave PIX"
	},
	"form": {
		"contactAndAddressSubtitle": "Información de contacto y dirección",
		"saving": "Guardando...",
		"maxAttemptsReached": "Máximo de intentos alcanzado ({current}/{max})",
		"waitCooldown": "Espere {seconds}s",
		"reset": "Reiniciar",
		"submissionBlockedTooltip": "Envío bloqueado - Intentos: {current}/{max}",
		"cooldownTooltip": "Espera: {seconds}s"
	}
}
